// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".taxInfo-Formatierung .taxInfoBlock[data-v-510d9132]{font-size:.6em !important;line-height:1.4em !important}.btn-input[data-v-510d9132]{border:1px solid #ced4da;background:#e9ecef}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
